import { computed } from "vue";
import { NavigationGuardNext, RouteLocationNormalizedGeneric, RouteLocationNormalizedLoadedGeneric } from "vue-router";

import { useOrderDetail } from "../../components/OrderShipmentData/store/OrderShipmentData.store";
import { useOrderStore } from "../../components/TableArticules/store/Order.store";




const isPreCompletedOrderGuard = async(
    _to:RouteLocationNormalizedGeneric, 
    _from:RouteLocationNormalizedLoadedGeneric, 
    next:NavigationGuardNext
) => {

    const orderDetail = useOrderDetail()
    const orderArticles = useOrderStore()

    // @ts-ignore
    const getAkeronService = computed(() => orderDetail.getAkeronService)
    const getOrderDetails = computed(() => orderDetail.getorderDetailState)
    const getOrderArticles = computed(() => orderArticles.getOrderArticles)

    try {
        
        // ? Esto comentado debera integrarse cuando el tomador web cotize con la API de Akeron
        // const isServiceEmpty = getAkeronService.value?.service.id === 0 && 
        //                      getAkeronService.value?.service.name === ""
        
        const isOrderDetailEmpty = getOrderDetails.value?.cliente_name === "" && 
                                 getOrderDetails.value?.dni === "" &&
                                 getOrderDetails.value?.email === ""

                                    
        if(isOrderDetailEmpty) {
            return next()
        }

        //! TERMINAR DE REDIRIGIR A ORDER-DETAIL SI HAY DATOS EN LOCALSTORAGE DE DETALLES DE ENVIOS Y ARTICULOS
        //! TERMINAR DE REDIRIGIR A ORDER-DETAIL SI HAY DATOS EN LOCALSTORAGE DE DETALLES DE ENVIOS Y ARTICULOS

        if(!isOrderDetailEmpty && getOrderArticles.value.length > 0){
            return next()
        }
    
        

        return next()

    } catch (error) {
        console.error('Error de autenticacion: ', error)
        return next({
            name: 'home'
        })
    }


}



export default isPreCompletedOrderGuard;
